<template>
    <div class="wrap">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <v-main class="main">
            <slot />
        </v-main>

        <user-qrcode />

        <!-- 푸터 -->
        <main-footer><!-- 기업정보 --></main-footer>

        <ScrollTop/>
    </div>
</template>

<script>
import UserQrcode from "@/components/client/inc/user-qrcode.vue";
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import ScrollTop from "@/components/client/dumb/scroll-top.vue";
export default {
    props: {
        isMain: { type: Boolean, default: true },
    },
    components: {
        UserQrcode,
        MainHeader,
        MainFooter,
        ScrollTop
    },
    mounted() {
        this.init();
    },
    methods: {
        init : function() {
            setTimeout(() => {
                AOS.init({
                    once: true,
                    offset: 240,
                    duration: 800,
                    throttleDelay : 100,
                    easing : 'ease-in-out',
                    anchorPlacement : 'top-center',
                });
            }, 100);
		}
    },
};
</script>
